"use strict";

exports.__esModule = true;
exports.default = void 0;
var _awsAmplify = require("aws-amplify");
var _states = _interopRequireDefault(require("./states"));
var _helpers = require("./helpers");
var _optinentries = require("../optinentries");
var _axios = _interopRequireDefault(require("axios"));
var _actionTypes = require("./actionTypes");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const initial = {
  session: {
    creating: false,
    data: null,
    error: null
  },
  user: null,
  me: {
    fetched: false,
    data: null,
    expand: "FlatPermissions",
    helpers: new class {
      constructor() {
        _defineProperty(this, "isAllowed", string => {
          if (!string) return true;
          const {
            data
          } = this;
          if (!data) return false;
          if (!data.FlatPermissions) return false;
          return (0, _helpers.permissionCheck)(data.FlatPermissions, string);
        });
        this.data = null;
      }
    }()
  },
  state: _states.default.LOGGED_OUT,
  fetching: false,
  error: null,
  message: null,
  selfSignUp: false,
  invitedSignUp: true,
  credentials: {
    username: null,
    password: null
  },
  passwordRules: {
    hasNumber: true,
    hasLetter: true,
    hasUppercase: true,
    minLength: 8,
    noSpecialChar: true
  },
  groups: [],
  config: {
    region: null,
    userPoolId: null,
    userPoolWebClientId: null
  },
  onSignInRedirect: "/downloadapp",
  onSignUpRedirect: "/post-sign-up",
  onSignOutRedirect: "/sign-in",
  onResetPasswordRedirect: "/sign-in",
  onUnauthorizedRedirect: "/sign-in",
  onAuthenticateSuccess: (props, response) => {
    if (props.location.pathname !== "/imprint") {
      props.dispatch(() => _optinentries.actions.getMyOptins()).then(optins => {
        if (optins.length) optins.map(optin => {
          return props.dispatch(() => {
            return {
              type: _actionTypes.CREATE_CUSTOM_CHALLENGE,
              data: {
                id: optin.Id,
                type: _actionTypes.OPTIN_CHALLENGE,
                data: optin,
                respond: ({
                  optin,
                  challenge
                }) => {
                  props.dispatch(() => _optinentries.actions.acceptMyOptin(optin)).then(() => {
                    props.dispatch({
                      type: _actionTypes.SOLVE_CUSTOM_CHALLENGE,
                      data: challenge
                    });
                  });
                }
              }
            };
          });
        });
      }).catch(error => {
        if (_axios.default.isCancel(error)) {
          return response;
        }
      });
    }
  }
};
const auth = (state = initial, action) => {
  switch (action.type) {
    case _actionTypes.INIT_AUTH:
      {
        const {
          config,
          ...rest
        } = action.data;
        _awsAmplify.Auth.configure({
          Auth: config
        });
        return {
          ...state,
          config: {
            ...state.config,
            ...config
          },
          ...rest
        };
      }
    case _actionTypes.CREATE_SESSION_REQUEST:
      return {
        ...state,
        session: {
          ...state.session,
          creating: true
        }
      };
    case _actionTypes.CREATE_SESSION_SUCCESS:
      return {
        ...state,
        session: {
          ...state.session,
          creating: false,
          data: action.data
        }
      };
    case _actionTypes.CREATE_SESSION_FAILURE:
      return {
        ...state,
        session: {
          ...state.session,
          creating: false,
          error: action.data
        }
      };
    case _actionTypes.GET_SESSION_REQUEST:
      return {
        ...state,
        session: {
          ...state.session,
          creating: true
        }
      };
    case _actionTypes.GET_SESSION_SUCCESS:
      if (Array.isArray(action.data) && action.data.length > 0) {
        return {
          ...state,
          session: {
            ...state.session,
            creating: false,
            data: action.data[0]
          }
        };
      } else {
        return {
          ...state,
          session: {
            ...state.session,
            creating: false,
            data: action.data
          }
        };
      }
    case _actionTypes.GET_SESSION_FAILURE:
      return {
        ...state,
        session: {
          ...state.session,
          creating: false,
          error: action.data
        }
      };
    case _actionTypes.DELETE_SESSION_REQUEST:
      return {
        ...state,
        session: {
          ...state.session,
          deleting: true
        }
      };
    case _actionTypes.DELETE_SESSION_SUCCESS:
      return {
        ...state,
        session: {
          ...state.session,
          deleting: false,
          data: action.data
        }
      };
    case _actionTypes.DELETE_SESSION_FAILURE:
      return {
        ...state,
        session: {
          ...state.session,
          deleting: false,
          error: action.data
        }
      };
    case _actionTypes.AUTHENTICATE_REQUEST:
      return {
        ...state,
        state: _states.default.LOGGING_IN
      };
    case _actionTypes.AUTHENTICATE_SUCCESS:
      return {
        ...state,
        state: _states.default.LOGGED_IN,
        user: action.data,
        error: null,
        message: "You authenticated successfully!"
      };
    case _actionTypes.AUTHENTICATE_FAILURE:
      return {
        ...state,
        state: _states.default.LOGGED_OUT,
        user: action.user
      };
    case _actionTypes.SIGNUP_REQUEST:
      return state;
    case _actionTypes.SIGNUP_SUCCESS:
      return state;
    case _actionTypes.SIGNUP_FAILURE:
      return state;
    case _actionTypes.SIGNIN_REQUEST:
      return {
        ...state,
        credentials: action.data,
        state: _states.default.LOGGING_IN
      };
    case _actionTypes.SIGNIN_SUCCESS:
      switch (action.data.challengeName) {
        case _actionTypes.NEW_PASSWORD_REQUIRED:
          return {
            ...state,
            state: _states.default.NEW_PASSWORD_REQUIRED,
            user: action.data,
            error: null,
            message: "New password required (temp pw)"
          };
      }
      return {
        ...state,
        state: _states.default.LOGGED_IN,
        user: action.data,
        error: null,
        message: "You logged in successfully!"
      };
    case _actionTypes.SIGNIN_FAILURE:
      switch (action.data.code) {
        case _actionTypes.PASSWORD_RESET_REQUIRED_EXCEPTION:
          return {
            ...state,
            state: _states.default.PASSWORD_RESET_REQUIRED,
            error: action.data,
            message: null
          };
        case _actionTypes.USER_NOT_CONFIRMED_EXCEPTION:
          return {
            ...state,
            state: _states.default.EMAIL_VERIFICATION_REQUIRED /* EMAIL_VERIFICATION_REQUIRED */,
            error: action.data
          };
        default:
          action.data.message = "Incorrect username or password.";
          return {
            ...state,
            state: _states.default.LOGGED_OUT,
            error: action.data,
            message: null
          };
      }
    case _actionTypes.SIGNOUT_REQUEST:
      return state;
    case _actionTypes.SIGNOUT_SUCCESS:
      state.me.helpers.data = null;
      return {
        ...state,
        state: _states.default.LOGGED_OUT,
        user: null,
        me: {
          ...state.me,
          data: null,
          fetched: false,
          failed: false
        },
        permissions: [],
        message: "You signed out successfully!"
      };
    case _actionTypes.QUIT_SUCCESS:
      state.me.helpers.data = null;
      return {
        ...state,
        state: _states.default.LOGGED_OUT,
        user: null,
        me: {
          ...state.me,
          data: null,
          fetched: false,
          failed: false
        },
        permissions: [],
        message: null
      };
    case _actionTypes.SIGNOUT_FAILURE:
      return state;
    case _actionTypes.RESET_PASSWORD_REQUEST:
      return {
        ...state,
        fetching: true
      };
    case _actionTypes.RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        state: _states.default.LOGGED_OUT,
        fetching: false,
        message: "Your password was successfully reset!",
        error: null
      };
    case _actionTypes.RESET_PASSWORD_FAILURE:
      return {
        ...state,
        fetching: false,
        message: null,
        error: action.data
      };
    case _actionTypes.NEW_PASSWORD_REQUEST:
      return {
        ...state,
        fetching: true
      };
    case _actionTypes.NEW_PASSWORD_SUCCESS:
      return {
        ...state,
        fetching: false,
        message: "Your new password was successfully set!",
        error: null
      };
    case _actionTypes.NEW_PASSWORD_FAILURE:
      return {
        ...state,
        fetching: false,
        message: null,
        error: action.data
      };
    case _actionTypes.NO_LOGIN_PERMISSION_EXCEPTION:
      if (state.customErrorMessages && state.customErrorMessages.noLoginPermission) action.data.message = state.customErrorMessages.noLoginPermission;
      return {
        ...state,
        state: _states.default.LOGGED_OUT,
        error: action.data
      };
    case _actionTypes.PASSWORD_RESET_REQUIRED_EXCEPTION:
      return {
        ...state,
        state: _states.default.PASSWORD_RESET_REQUIRED,
        error: action.error
      };
    case _actionTypes.NOT_AUTHORIZED_EXCEPTION:
      return {
        ...state,
        state: _states.default.LOGGED_OUT,
        error: action.error
      };
    case _actionTypes.USER_NOT_FOUND_EXCEPTION:
      return {
        ...state,
        state: _states.default.LOGGED_OUT,
        error: action.error
      };
    case _actionTypes.INVALID_PASSWORD_EXCEPTION:
      return {
        ...state,
        // state: CognitoState.LOGGED_OUT,
        error: action.error
      };
    case _actionTypes.LIMIT_EXEEDED_EXCEPTION:
      return {
        ...state,
        // state: CognitoState.LOGGED_OUT,
        message: null,
        error: action.error
      };
    case _actionTypes.SEND_VERIFICATION_CODE_REQUEST:
      return {
        ...state,
        fetching: true,
        message: null,
        error: null,
        credentials: {
          ...state.credentials,
          username: action.username
        }
      };
    case _actionTypes.SEND_CODE_SUCCESS:
      return {
        ...state,
        state: _states.default.PASSWORD_RESET_REQUIRED,
        credentials: action.data,
        fetching: false,
        error: null,
        message: `A verification code has been sent to ${action.data.username}`
      };
    case _actionTypes.SEND_CODE_FAILURE:
      return {
        ...state,
        fetching: false,
        error: action.data
      };
    case _actionTypes.GET_ME_SUCCESS:
      state.me.helpers.data = action.data;
      window.isAllowed = state.me.helpers.isAllowed;
      return {
        ...state,
        me: {
          ...state.me,
          data: action.data,
          fetched: true,
          failed: false
        }
      };
    case _actionTypes.GET_ME_FAILURE:
      return {
        ...state,
        me: {
          ...state.me,
          data: null,
          fetched: false,
          failed: true
        }
      };
    case _actionTypes.ACTIVATE_MAINTENANCE_MODE:
      return {
        ...state,
        state: "MAINTENANCE_MODE",
        data: action.data
      };
    case _actionTypes.CREATE_CUSTOM_CHALLENGE:
      if (state.challenges && state.challenges.find(challenge => challenge.id === action.data.id)) return state;
      return {
        ...state,
        state: "CUSTOM_CHALLENGE",
        challenges: [...(state.challenges ? state.challenges : []), {
          ...action.data,
          continue: state.state
        }]
      };
    case _actionTypes.SOLVE_CUSTOM_CHALLENGE:
      return {
        ...state,
        challenges: state.challenges.filter(challenge => challenge.id !== action.data.id),
        state: action.data.continue
      };
    case _actionTypes.UPDATE_ME_REQUEST:
      return {
        ...state,
        me: {
          ...state.me,
          fetching: true
        }
      };
    case _actionTypes.UPDATE_ME_SUCCESS:
      state.me.helpers.data = action.data;
      return {
        ...state,
        me: {
          ...state.me,
          data: {
            ...action.data,
            UserImage: state.me.data.UserImage
          },
          fetched: true,
          fetching: false
        }
      };
    case _actionTypes.UPDATE_ME_FAILURE:
      return {
        ...state,
        me: {
          ...state.me,
          fetched: true,
          fetching: false,
          error: action.data
        }
      };
    case _actionTypes.CREATE_USERIMAGE_REQUEST:
      return {
        ...state,
        me: {
          ...state.me,
          fetching: true
        }
      };
    case _actionTypes.CREATE_USERIMAGE_SUCCESS:
      return {
        ...state,
        me: {
          ...state.me,
          fetched: true,
          fetching: false,
          data: {
            ...state.me.data,
            UserImage: action.data
          }
        }
      };
    case _actionTypes.CREATE_USERIMAGE_FAILURE:
      return {
        ...state,
        me: {
          ...state.me,
          fetched: true,
          fetching: false,
          error: action.data
        }
      };
    case _actionTypes.UPDATE_USERIMAGE_REQUEST:
      return {
        ...state,
        me: {
          ...state.me,
          fetching: true
        }
      };
    case _actionTypes.UPDATE_USERIMAGE_SUCCESS:
      return {
        ...state,
        me: {
          ...state.me,
          fetched: true,
          fetching: false,
          data: {
            ...state.me.data,
            UserImage: action.data
          }
        }
      };
    case _actionTypes.UPDATE_USERIMAGE_FAILURE:
      return {
        ...state,
        me: {
          ...state.me,
          fetched: true,
          fetching: false,
          error: action.data
        }
      };
    case _actionTypes.DELETE_USERIMAGE_REQUEST:
      return {
        ...state,
        me: {
          ...state.me,
          fetching: true
        }
      };
    case _actionTypes.DELETE_USERIMAGE_SUCCESS:
      {
        const {
          ...newData
        } = state.me.data;
        return {
          ...state,
          me: {
            ...state.me,
            fetched: true,
            fetching: false,
            data: newData
          }
        };
      }
    case _actionTypes.DELETE_USERIMAGE_FAILURE:
      return {
        ...state,
        me: {
          ...state.me,
          fetched: true,
          fetching: false,
          error: action.data
        }
      };
    default:
      return state;
  }
};
var _default = exports.default = auth;
module.exports = exports.default;